import Box from '@mui/material/Box';

import { TypoPoppins } from '../../../Components/Typo';
import CardLayout from '../../../Components/CardLayout';

function ServicePackageCard({ data }) {
  return (
    <CardLayout>
      <Box
        display='grid'
        gridTemplateColumns='auto 1fr'
        rowGap={2}
        columnGap={1}
      >
        <TypoPoppins>ID</TypoPoppins>
        <TypoPoppins>{data.servicePackageId}</TypoPoppins>
        <TypoPoppins>Name</TypoPoppins>
        <TypoPoppins>{data.name}</TypoPoppins>
        <TypoPoppins>Price</TypoPoppins>
        <TypoPoppins>{data.price}</TypoPoppins>
        <TypoPoppins>Description</TypoPoppins>
        <TypoPoppins>{data.description}</TypoPoppins>
      </Box>
    </CardLayout>
  );
}

export default ServicePackageCard;
